<template>
  <div>
    <div>
      <div v-if="onlineSale && floorPlanAvailable && !event.soldOut" style="margin-bottom: 2.5rem">
        <module-title
          v-if="!isZkm"
          color="#333333"
          :title="$t('buyATicket')"
          :font-style="titleStyle"
        />
        <module-title v-else :color="secondaryColor" :title="$t('buyATicketZkm')" :event="event" />
      </div>
      <div v-if="!floorPlanAvailable || event.soldOut">
        <div class="no-tickets">
          <div
            v-if="isTheaterOrganization"
            class="d-flex justify-center"
            style="cursor: pointer"
            @click="goToEventDetailsPage"
          >
            <div class="">
              <img class="" src="/assets/keyboard-arrow-back.svg" alt="Back Button" />
            </div>
            <div class="text-uppercase font-weight-bold pl-2">{{ $t('backToEvent') }}</div>
          </div>

          <img :src="getModalImage" alt="no tickets" />
          <module-title
            color="#333333"
            :title="getModalTitle"
            :description="getModalDescription"
            :show-events-button="true"
            :show-ticket-swap-button="event.soldOut && !event.canceled"
            :event="event"
            class="pb-4"
          />
        </div>
      </div>
      <div v-if="isZkm" style="height: 100px" />
      <div v-if="!loading && floorPlanAvailable && !event.soldOut && parterAsTicket.length">
        <ticket-card
          v-for="orderItem in parterAsTicket"
          :ticket="orderItem"
          :event="event"
          :promo-code="promoCode"
          :can-add-more="canAddMoreTickets && canAddParterTicket(orderItem)"
          :items="selectedTicket"
          color="#333333"
          style="margin-bottom: 1rem"
          background-color="#3333330d"
          active-background-color="white"
          @added="addParterAsTicketToCart(orderItem)"
          @removed="removeParterAsTicketToCart(orderItem)"
        />
      </div>
      <div
        v-if="floorPlanAvailable && !event.soldOut"
        :class="['floor-plan-wrapper', isZkm && 'floor-plan-wrapper-zkm']"
        :style="!onlineSale && 'margin-top: 1rem'"
      >
        <div
          :class="['title-ticket-wrapper', isZkm && 'title-ticket-wrapper-zkm']"
          :style="!onlineSale && 'background: white'"
        >
          <p v-if="onlineSale" :class="['description-title', isZkm && 'description-title-zkm']">
            {{ isZkm ? $t('ticketCategoryZkm') : $t('ticketCategory') }}
          </p>
          <div :class="['ticket-wrapper', isZkm && 'ticket-wrapper-zkm']">
            <v-select
              v-if="event.organization.type === 'THEATER' && !loading"
              v-model="currTicket"
              :items="getOrderItems"
              item-text="displayTicketLabel"
              item-value="id"
              @change="handleTicketClick"
            >
              <template v-slot:item="{ item }">
                <div v-html="item.displayTicketLabel" />
              </template>
              <template v-slot:selection="{ item }">
                <div v-html="item.displayTicketLabel" />
              </template>
            </v-select>
            <div v-for="ticket in orderItems" v-else :key="ticket.id">
              <div
                v-if="
                  ticket.sectionSeats.length && (onlineSale || (!onlineSale && ticket.price > 0))
                "
                :id="ticket.id"
                class="ticket-container"
              >
                <div :style="`background:${ticket.color}`" class="ticket-color" />
                <p class="ticket-name">
                  {{ ticket.name }}
                </p>
                <p class="ticket-price-currency">
                  {{ ticket.price }}
                  {{ ticket.currency }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div id="spinner-svg-wrapper">
          <div v-if="loadingSvg" id="spinner-container">
            <spinner />
          </div>
          <div v-if="!loading" style="position: relative">
            <floor-plan-element-dialog
              v-if="dialogElement"
              :open-dialog="openFloorPlanElementDialog"
              :order-item="dialogElement"
              :quantity-limit="seatLimitPerOrder"
              :current-selected-amount="getNumOfSelectedElements()"
              :initial-quantity="initialFloorPlanDialogElementQuantity"
              @removeTicketFromOrder="removeDialogElementFromOrder"
              @addTickets="addDialogElementFromOrder($event)"
            />
            <object id="svgfile" :data="venue.imageUrl" type="image/svg+xml" style="width: 100%" />
            <seat-info
              :seat="hoveredSeat"
              :show-info="seatInfoVisible"
              :position="seatInfoPosition"
              :ticket="currTicket"
              :order-items="orderItems"
            />
            <div id="svg-action-buttons-wrapper" style="display: none">
              <v-icon
                id="zoomIn"
                class="material-icons"
                :size="43"
                :color="isZkm ? '#333' : zoomInIconColor"
              >
                add_circle
              </v-icon>
              <v-icon
                id="zoomOut"
                class="material-icons"
                :size="43"
                :color="isZkm ? '#333' : zoomInIconColor"
              >
                remove_circle
              </v-icon>
              <v-icon
                id="resetZoom"
                class="material-icons"
                :size="43"
                :color="isZkm ? '#333' : zoomInIconColor"
              >
                replay_circle_filled
              </v-icon>
            </div>
          </div>
        </div>
        <div v-if="isZkm" class="zkm-seat-availability">
          <div v-if="isTheaterOrganization" class="seat-state-description-zkm">
            <div class="available-seat" />
            <span>{{ $t('available') }}</span>
          </div>
          <div class="seat-state-description-zkm">
            <div class="unavailable-seat" />
            <span>{{ $t('unavailable') }}</span>
          </div>
          <div class="seat-state-description-zkm">
            <div class="selected-seat" :style="{ background: getTicketColor }" />
            <span>{{ $t('selected') }}</span>
          </div>
        </div>
        <div :class="['seat-state-wrapper', isZkm && 'seat-state-wrapper-zkm']">
          <div v-if="isTheaterOrganization" class="seat-state-description">
            <div class="available-seat" />
            <span>{{ $t('available') }}</span>
          </div>
          <div class="seat-state-description">
            <div class="unavailable-seat" />
            <span>{{ $t('unavailable') }}</span>
          </div>
          <div class="seat-state-description">
            <div class="selected-seat" :style="{ background: getTicketColor }" />
            <span>{{ $t('selected') }}</span>
          </div>
        </div>
      </div>
      <simple-snackbar
        :open.sync="snackbarOpen"
        :message-prop="snackbarMessage"
        :color="snackbarColor"
      />
    </div>
  </div>
</template>

<script>
import ModuleTitle from './../../shared/module-title.vue'
import Spinner from '../../shared/spinner'
import { GET_EVENT_FLOOR_PLAN_AND_ORDER_ITEMS } from '@/graphql/event.graphql'
import SimpleSnackbar from '../../shared/snackbars/simple-snackbar.vue'
import moment from 'moment'
import { cloneDeep, isEmpty } from 'lodash'
import * as svgPanZoom from 'svg-pan-zoom'
import * as Hammer from 'hammerjs'
import SeatInfo from '../seat-info.vue'
import { OrganizationType, SeatState, SvgElementCEType, TicketType, Venue } from '@/types'
import FloorPlanElementDialog from '@/components/accreditations/register-stepper/floor-plan-element-dialog.vue'
import TicketCard from '@/components/tickets/ticket-card.vue'
import { getOrder } from '@/http'

export default {
  components: {
    TicketCard,
    FloorPlanElementDialog,
    ModuleTitle,
    Spinner,
    SimpleSnackbar,
    SeatInfo,
  },
  props: {
    onlineSale: {
      type: Boolean,
      default: true,
    },
    initialPromoCode: {
      type: String,
      default: null,
    },
    initialSeatSelect: {
      type: Object,
      default: null,
    },
    ticketLocations: {
      type: Object,
      default: () => {},
    },
    updatedOrderItems: {
      type: Object,
      default: () => {},
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    event: {
      type: Object,
      default: null,
    },
    initialValues: {
      type: Array,
      default: () => [],
    },
    promoCode: {
      type: Object,
      default: null,
    },
    membership: {
      type: Object,
      default: null,
    },
    sellableOrderItemIds: {
      type: Array,
    },
  },
  data() {
    return {
      seatInfoPosition: { left: '0', top: '0' },
      seatInfoVisible: false,
      hoveredSeat: null,
      venue: null,
      snackbarOpen: false,
      snackbarMessage: '',
      snackbarColor: null,
      canAddMoreTickets: true,
      seatLimitPerOrder: [1783, 1784, 1785].includes(parseInt(this.event.id)) ? 500 : 10,
      initialFloorPlanDialogElementQuantity: 1,
      floorPlanAvailable: true,
      openFloorPlanElementDialog: false,
      zoomInIconColor: '#0277BD',
      zoomOutIconColor: '#0277BD',
      resetZoomIconColor: '#0277BD',
      SvgElementCEType,
      seatState: {
        HOLD: 'hold',
        SOLD: 'sold',
        AVAILABLE: 'available',
      },
      eventListenerType: {
        true: 'touchstart',
        false: 'click',
      },
      isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
      orderItems: null,
      allOrderItems: null,
      loadingSvg: true,
      venueAvailability: null,
      initialParterIds: [],
      maxZoom: 3,
      clientY: null,
      dialogElement: null,
      dialogElementId: null,
      clientX: null,
      currTicket: null,
      elementDetails: {},
      parterAsTicket: [],
      venueSections: [],
      drag: false,
      selectedTicket: [...cloneDeep(this.initialValues)] || [],
      selectedSeats: [],
      requiredSeats: [],
      selectPromo: false,
      secondaryColor: '#FF4C00',
      titleStyle: {
        fontFamily: 'Raleway',
        fontSize: '2.25rem',
        fontStyle: 'normal',
        fontWeight: '800',
        lineHeight: '120%',
        letterSpacing: '-0.0675rem',
      },
      loading: true,
    }
  },
  computed: {
    getTicketColor() {
      if (!this.currTicket) return 'white'
      const ticket = this.orderItems.find(oi => oi.id === this.currTicket)
      if (!ticket) return 'white'

      return ticket.color
    },
    getModalTitle() {
      if (this.event.canceled) {
        return this.$t('eventCanceled')
      }

      if (this.event.soldOut) {
        return this.$t('ticketSoldOut')
      }

      return this.$t('ticketUnavailable')
    },
    getModalDescription() {
      if (this.event.canceled) {
        return this.$t('eventCanceledDescription')
      }

      if (this.event.soldOut) {
        return this.$t('ticketSoldOutDescription')
      }

      if (this.event && this.event.organization && this.event.organization.id === 502) {
        return ''
      }

      return this.$t('ticketUnavailableDescription')
    },
    getModalImage() {
      if (this.event.canceled) {
        return '/assets/sad-ticket.svg'
      }

      if (this.event.soldOut) {
        return '/assets/sad-ticket.svg'
      }

      return '/assets/dont-know-ticket.svg'
    },
    isZkm() {
      if (!this.event || !this.event.organization) {
        return false
      }

      return this.event.organization.id == process.env.VUE_APP_ZKM_ORGANIZATION_ID
    },
    isTheaterOrganization() {
      if (!this.event || !this.event.organization) {
        return false
      }

      return this.event.organization.type === OrganizationType.THEATER
    },
    getOrderItems() {
      return this.orderItems.filter(
        ticket =>
          ticket.sectionSeats.length && (this.onlineSale || (!this.onlineSale && ticket.price > 0)),
      )
    },
  },
  watch: {
    updatedOrderItems: function () {
      for (const [orderItemId, value] of Object.entries(this.updatedOrderItems)) {
        if (!orderItemId) {
          continue
        }

        const orderItem = this.orderItems.find(oi => oi.id === orderItemId)
        if (!orderItem) {
          continue
        }

        const currentQuantity = this.selectedTicket.filter(t => t.id === orderItemId).length
        const newQuantity = value.quantity
        const quantityDifference = currentQuantity - newQuantity

        if (quantityDifference > 0) {
          for (let i = 0; i < quantityDifference; i++) {
            const index = this.selectedTicket.findIndex(t => t.id === orderItemId)
            if (index !== -1) {
              this.selectedTicket.splice(index, 1)
            }
          }
        }

        orderItem.quantity = newQuantity

        const isParterAsTicket = this.parterAsTicket.some(t => t.id === orderItemId)

        if (isParterAsTicket) {
          if (this.elementDetails[orderItemId]) {
            this.$set(this.elementDetails, orderItemId, newQuantity)
          }
          this.$emit('addDialogElementToOrder', [orderItem, newQuantity, TicketType.REGULAR])
        } else {
          const elementIds = orderItem.sectionSeats
          elementIds.forEach(elementId => {
            if (elementId && this.elementDetails[elementId]) {
              this.$set(this.elementDetails, elementId, newQuantity)
            }

            if (newQuantity <= 0) {
              const svgDoc = document.getElementById('svgfile').getSVGDocument()
              if (svgDoc && svgDoc.getElementById(elementId)) {
                svgDoc.getElementById(elementId).style.fill = '#979797'
              }
            }
            this.$emit('addDialogElementToOrder', [
              orderItem,
              newQuantity,
              TicketType.REGULAR,
              elementId,
            ])
          })
        }
      }
    },
    requiredSeats: {
      handler() {
        this.$emit('requiredSeats', this.requiredSeats)
      },
    },
  },
  mounted() {
    !this.event.venueId && (this.floorPlanAvailable = false)
    this.membership && this.addPromo()
    if (this.initialSeatSelect) {
      let seatIds = []

      this.initialSeatSelect.purchases.map(p => {
        if (p.orderItem.itemMeta.parter) {
          this.initialParterIds.push(p.accreditation.ticketLocation)
        } else {
          seatIds.push(p.accreditation.ticketLocation)
        }
      })
      this.selectedSeats = [...new Set(seatIds)]
    }
  },
  apollo: {
    getEventFloorPlanAndOrderItems: {
      query: GET_EVENT_FLOOR_PLAN_AND_ORDER_ITEMS,
      variables() {
        return {
          eventId: this.event.id,
          includeOrderItemsWithTicketSellerTrue: !this.onlineSale,
        }
      },
      manual: true,
      async result({ data, errors }) {
        if (errors) {
          return (this.floorPlanAvailable = false)
        }
        this.venue = data.getEventFloorPlanAndOrderItems.venue
        this.allOrderItems = data.getEventFloorPlanAndOrderItems.orderItems.filter(oi =>
          moment().isBetween(oi.from, oi.to),
        )
        this.orderItems = this.mapOrderItems(data.getEventFloorPlanAndOrderItems.orderItems)
        if (this.event.organization.type === OrganizationType.THEATER) {
          this.orderItems = this.orderItems.sort((a, b) => b.price - a.price)
        }

        if (this.sellableOrderItemIds) {
          this.orderItems = this.orderItems.filter(oi => this.sellableOrderItemIds.includes(oi.id))
        }
        this.venueAvailability =
          (data.getEventFloorPlanAndOrderItems.venueAvailability &&
            data.getEventFloorPlanAndOrderItems.venueAvailability.availability) ||
          {}
        const parterTickets = data.getEventFloorPlanAndOrderItems.orderItems.filter(
          oi => moment().isBetween(oi.from, oi.to) && oi.itemMeta.parter,
        )
        if (!this.orderItems.length) {
          return (this.floorPlanAvailable = false)
        }

        const hasNoAvailableSeats =
          !this.venueAvailability ||
          !Object.values(this.venueAvailability).some(seat => seat.state === SeatState.AVAILABLE)
        const hasNoAvailableParterTickets = !parterTickets.some(oi => Number(oi.quantity) > 0)

        if (hasNoAvailableSeats && hasNoAvailableParterTickets) {
          return (this.event.soldOut = true)
        }
        this.membership && this.addMembershipOrderItem(this.membership)
        this.setOrderLimitation(this.orderItems)

        this.loading = false

        // problem with rendering SVG file
        setTimeout(() => {
          document.getElementById('svgfile').addEventListener('load', () => {
            this.hammerInit()
            const svgDoc = document.getElementById('svgfile').getSVGDocument()
            if (this.orderItems.length) {
              const startTicket = this.orderItems.find(oi => oi.prepaidCoupon && !oi.membership)
              this.handleTicketClick((startTicket && startTicket.id) || this.orderItems[0].id)
            }
            this.initialSvgColors(svgDoc)
            this.initialTableAndParterDataAndColoring(svgDoc)
            this.loadingSvg = false
            document.getElementById('spinner-svg-wrapper').style.height = 'fit-content'
            document.getElementById('svg-action-buttons-wrapper').style.display = 'flex'
          })
        }, 0)
      },
    },
  },
  methods: {
    getOrder,
    goToEventDetailsPage() {
      const url = `${process.env.VUE_APP_LANDING_URL}/events/${this.event.slug}`
      window.open(url, '_blank')
    },
    initialTableAndParterDataAndColoring(svgDoc) {
      if (this.selectedSeats.length || this.initialParterIds.length) {
        const tableAndParterLocationIds = this.initialSeatSelect.purchases
          .map(p => {
            const isTableTicket =
              this.getSvgElementType(svgDoc, p.accreditation.ticketLocation) ===
              this.SvgElementCEType.TABLE
            const isParterTicket =
              this.getSvgElementType(svgDoc, p.accreditation.ticketLocation) ===
              this.SvgElementCEType.PARTER
            if (isTableTicket) {
              return p.accreditation.ticketLocation
            } else if (isParterTicket) {
              svgDoc.getElementById(p.accreditation.ticketLocation).style.fill = p.orderItem.color

              return p.accreditation.ticketLocation
            }
          })
          .filter(Boolean)
        tableAndParterLocationIds.map(
          id => (this.elementDetails[id] = (this.elementDetails[id] || 0) + 1),
        )
      }
    },
    mapOrderItems(data) {
      return data
        .filter(oi => moment().isBetween(oi.from, oi.to) && !oi.membership)
        .map(orderItem => {
          return {
            ...orderItem,
            displayTicketLabel: `
            <div style="display: inline-flex; align-items: center;">
              <span style="
                display: inline-block;
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: ${orderItem.color};
                margin-right: 8px;">
              </span>
              <strong>${orderItem.name} - ${orderItem.price} ${orderItem.currency}</strong>
            </div>
          `,
          }
        })
    },
    showSeatInfo(seat, event) {
      this.hoveredSeat = seat
      this.seatInfoVisible = true
      this.seatInfoPosition = {
        left: event.clientX + 8 + 'px',
        top: event.clientY + 'px',
      }
    },
    hideSeatInfo() {
      this.seatInfoVisible = false
    },
    setOrderLimitation() {
      if ([4242, 4243].includes(parseInt(this.event.id))) {
        this.seatLimitPerOrder = 6
      } else {
        this.seatLimitPerOrder = Math.max(
          10,
          ...this.orderItems.map(oi => oi.itemMeta.max).filter(Boolean),
        )
      }
    },
    getNumOfSelectedElements() {
      let selectedNum = 0
      this.selectedSeats.map(id => {
        selectedNum += this.elementDetails[id] || 1
      })
      for (const [key, value] of Object.entries(this.elementDetails)) {
        !this.selectedSeats.includes(key) && (selectedNum += value)
      }

      return selectedNum
    },
    removeDialogElementFromOrder() {
      this.switchElementDialogState()
      this.clearElementDetailsAndLocationInfo()
    },
    addDialogElementFromOrder(ticketQuantity) {
      const orderItem = this.orderItems.find(
        oi => moment().isBetween(oi.from, oi.to) && oi.sectionSeats.includes(this.dialogElementId),
      )
      const svgDoc = document.getElementById('svgfile').getSVGDocument()
      this.switchElementDialogState()
      if (this.getSvgElementType(svgDoc, this.dialogElementId) === SvgElementCEType.PARTER) {
        ticketQuantity === 0 && delete this.elementDetails[this.dialogElementId]
      } else {
        this.addWhiteColorOnElementSelect(this.dialogElementId, svgDoc)
        this.selectedTicket.push(orderItem)
        this.selectedSeats.push(this.dialogElementId)
        svgDoc.getElementById(this.dialogElementId).setAttribute('ticketId', orderItem.id)
      }
      this.$emit('addDialogElementToOrder', [
        this.dialogElement,
        ticketQuantity,
        this.getSvgElementType(svgDoc, this.dialogElementId),
        this.dialogElementId,
      ])
      !!ticketQuantity && this.$set(this.elementDetails, this.dialogElementId, ticketQuantity)
      this.canAddMoreTickets = this.canAddMoreCheck()
      this.clearElementDetailsAndLocationInfo()
    },
    clearElementDetailsAndLocationInfo() {
      this.dialogElementId = null
      this.dialogElement = null
      this.initialFloorPlanDialogElementQuantity = 1
    },
    handleTicketClick(ticket) {
      if (this.event.eventTemplateId) {
        this.currTicket = ticket
        const svgDoc = document.getElementById('svgfile').getSVGDocument()
        this.handleSeatColoring(svgDoc)
      }
    },
    canAddMoreCheck() {
      return !(this.getNumOfSelectedElements() === this.seatLimitPerOrder)
    },
    oneFreeSeatBetweenSelectedSeatsCheck(seat, svgDoc) {
      if (this.requiredSeats.includes(seat)) {
        this.requiredSeats = this.requiredSeats.filter(reqSeat => reqSeat !== seat)
        this.addWhiteColorOnElementSelect(seat, svgDoc, this.currTicket)
      } else {
        const seatDetails = seat.split('_')
        const seatSection = seatDetails.find(sd => sd.includes('Section-'))
        const seatRow = seatDetails.find(sd => sd.includes('Row-'))
        const seatPosition = seatDetails.find(sp => sp.includes('Seat-'))
        const seatNumber = parseInt(seatPosition.split('-')[1])
        const rightSeatSpaceCheck =
          this.venueAvailability[`${seatSection}_${seatRow}_Seat-${seatNumber + 1}`] &&
          this.venueAvailability[`${seatSection}_${seatRow}_Seat-${seatNumber + 1}`].state ===
            this.seatState.AVAILABLE &&
          this.selectedSeats.includes(`${seatSection}_${seatRow}_Seat-${seatNumber + 2}`) &&
          !this.selectedSeats.includes(`${seatSection}_${seatRow}_Seat-${seatNumber + 1}`)
        const leftSeatSpaceCheck =
          this.venueAvailability[`${seatSection}_${seatRow}_Seat-${seatNumber - 1}`] &&
          this.venueAvailability[`${seatSection}_${seatRow}_Seat-${seatNumber - 1}`].state ===
            this.seatState.AVAILABLE &&
          this.selectedSeats.includes(`${seatSection}_${seatRow}_Seat-${seatNumber - 2}`) &&
          !this.selectedSeats.includes(`${seatSection}_${seatRow}_Seat-${seatNumber - 1}`)

        if (rightSeatSpaceCheck || leftSeatSpaceCheck) {
          if (rightSeatSpaceCheck) {
            this.requiredSeats.push(`${seatSection}_${seatRow}_Seat-${seatNumber + 1}`)
            svgDoc.getElementById(`${seatSection}_${seatRow}_Seat-${seatNumber + 1}`).style.fill =
              'red'
          }
          if (leftSeatSpaceCheck) {
            this.requiredSeats.push(`${seatSection}_${seatRow}_Seat-${seatNumber - 1}`)
            svgDoc.getElementById(`${seatSection}_${seatRow}_Seat-${seatNumber - 1}`).style.fill =
              'red'
          }
          this.snackbarColor = 'error'
          this.snackbarOpen = true
          this.snackbarMessage = this.$t('requiredSeatError')
        }

        return rightSeatSpaceCheck || leftSeatSpaceCheck
      }
    },
    triggerButtonClick() {
      if (this.requiredSeats.length) {
        return
      }
      this.handleSubmit()
    },
    triggerMembershipClick(membershipNumber) {
      this.applyMembership(membershipNumber)
    },
    handleSubmit() {
      if (this.membership) {
        const orderItem = this.orderItems.find(oi =>
          this.membership.membershipPlan.orderItemTemplates.some(
            oit => oit.id === parseInt(oi.orderItemTemplateId),
          ),
        )
        if (!this.ticketLocations[orderItem.id]) {
          this.$emit('removePromoCode')
        }
      }
      const orderInfo = [...this.selectedSeats]
      if (Object.keys(this.elementDetails).length) {
        for (const [key, value] of Object.entries(this.elementDetails)) {
          if (!document.getElementById('svgfile').getSVGDocument().getElementById(key)) {
            continue
          }
          const startFrom =
            this.getSvgElementType(document.getElementById('svgfile').getSVGDocument(), key) ===
            this.SvgElementCEType.TABLE
              ? 1
              : 0
          for (let i = startFrom; i < value; i++) {
            orderInfo.push(key)
          }
        }
      }
      this.$emit('next', orderInfo)
    },
    oneFreeSeatBetweenDeselectedSeatsCheck(seat, svgDoc) {
      const seatDetails = seat.split('_')
      const seatSection = seatDetails.find(sd => sd.includes('Section-'))
      const seatRow = seatDetails.find(sd => sd.includes('Row-'))
      const seatPosition = seatDetails.find(sp => sp.includes('Seat-'))
      const seatNumber = parseInt(seatPosition.split('-')[1])
      const rightSeatSpaceCheck = this.selectedSeats.includes(
        `${seatSection}_${seatRow}_Seat-${seatNumber + 1}`,
      )
      const leftSeatSpaceCheck = this.selectedSeats.includes(
        `${seatSection}_${seatRow}_Seat-${seatNumber - 1}`,
      )
      const removeSeatsFromRequired = this.requiredSeats.filter(
        rs =>
          rs === `${seatSection}_${seatRow}_Seat-${seatNumber + 1}` ||
          rs === `${seatSection}_${seatRow}_Seat-${seatNumber - 1}`,
      )
      removeSeatsFromRequired.map(s => {
        svgDoc.getElementById(s).style.fill = this.event.eventTemplateId
          ? '#979797'
          : this.orderItems.find(oi => oi.sectionSeats.includes(s)).color
        this.requiredSeats.splice(this.requiredSeats.indexOf(s), 1)
      })

      if (rightSeatSpaceCheck && leftSeatSpaceCheck) {
        this.requiredSeats.push(seat)
        svgDoc.getElementById(seat).style.fill = 'red'

        this.snackbarColor = 'error'
        this.snackbarOpen = true
        this.snackbarMessage = this.$t('requiredSeatError')
      }

      return rightSeatSpaceCheck || leftSeatSpaceCheck
    },
    addPromo() {
      return (this.selectPromo = !this.selectPromo)
    },
    getCurrZoom() {
      return window.panZoom.getZoom()
    },
    applyPromoCode(promoCodeInput) {
      this.$emit('applyPromo', promoCodeInput)
    },
    applyMembership(membershipInput) {
      this.snackbarColor = 'primary'
      this.snackbarOpen = true
      this.snackbarMessage = 'Vaše članstvo uključuje ulaznice po povlaštenoj cijeni.'
      this.$emit('applyMembership', membershipInput)
      this.addMembershipOrderItem(membershipInput)
    },
    addMembershipOrderItem(membershipInput) {
      const membershipTicket = this.allOrderItems.find(oi =>
        membershipInput.membershipPlan.orderItemTemplates.some(
          oit => oit.id === parseInt(oi.orderItemTemplateId),
        ),
      )

      this.orderItems = [
        ...this.orderItems,
        {
          ...membershipTicket,
          displayTicketLabel: `
            <div style="display: inline-flex; align-items: center;">
              <span style="
                display: inline-block;
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: ${membershipTicket.color};
                margin-right: 8px;">
              </span>
              <strong>${membershipTicket.name} - ${membershipTicket.price} ${membershipTicket.currency}</strong>
            </div>
          `,
        },
      ]

      setTimeout(() => {
        this.handleTicketClick(membershipTicket.id)
      }, 10)
    },

    removePromoCode() {
      if (this.membership) {
        const svgDoc = document.getElementById('svgfile').getSVGDocument()
        const membershipOrderItem = this.allOrderItems.find(oi =>
          this.membership.membershipPlan.orderItemTemplates.some(
            oit => oit.id === parseInt(oi.orderItemTemplateId),
          ),
        )
        this.currTicket = membershipOrderItem.id
        const removeSeatIds = []
        if (this.ticketLocations[membershipOrderItem.id]) {
          this.ticketLocations[membershipOrderItem.id].map(location => {
            location.seats.map(seat => {
              const seatId = `${location.section}_${location.row}_Seat-${seat}`
              removeSeatIds.push(seatId)
              svgDoc.getElementById(seatId).removeAttribute('stroke')
              svgDoc.getElementById(seatId).style.fill = '#979797'
              this.selectedSeats = this.selectedSeats.filter(seat => seat !== seatId)
            })
          })
        }
        removeSeatIds.map(id => this.removeTicketFromCart(membershipOrderItem, id, svgDoc))
        this.orderItems = this.orderItems.filter(
          oi =>
            !this.membership.membershipPlan.orderItemTemplates
              .map(oit => oit.id)
              .includes(parseInt(oi.orderItemTemplateId)),
        )
        this.selectedTicket = this.selectedTicket.filter(
          oi =>
            !this.membership.membershipPlan.orderItemTemplates
              .map(oit => oit.id)
              .includes(parseInt(oi.orderItemTemplateId)),
        )
        this.handleTicketClick(this.orderItems[0].id)
      }
      this.$emit('removePromoCode')
    },
    checkZoomButtonsState(isZoomingIn) {
      if (isZoomingIn) {
        if (this.getCurrZoom() >= this.maxZoom - 0.1) {
          this.zoomInIconColor = '#D9D9D9'
        }
        if (this.getCurrZoom() > 0.51) {
          this.zoomOutIconColor = '#0277BD'
        }
      } else {
        if (this.getCurrZoom() <= this.maxZoom - 0.1) {
          this.zoomInIconColor = '#0277BD'
        }
        if (this.getCurrZoom() <= 0.51) {
          this.zoomOutIconColor = '#D9D9D9'
        }
      }
    },
    setZoomButtonsActions(svgDoc) {
      document.getElementById('zoomIn').addEventListener(
        this.eventListenerType[this.isMobile],
        function () {
          window.panZoom.zoomIn()
          this.checkZoomButtonsState(true, svgDoc)
          this.hideSeatsAtSpecificZoom(1, this.getCurrZoom(), svgDoc)
        }.bind(this),
      )
      document.getElementById('zoomOut').addEventListener(
        this.eventListenerType[this.isMobile],
        function () {
          window.panZoom.zoomOut()
          this.checkZoomButtonsState(false, svgDoc)
          this.hideSeatsAtSpecificZoom(1, this.getCurrZoom(), svgDoc)
        }.bind(this),
      )
      document.getElementById('resetZoom').addEventListener(
        this.eventListenerType[this.isMobile],
        function () {
          window.panZoom.resetZoom().zoomOut()
          window.panZoom.center()
          this.zoomInIconColor = '#0277BD'
          this.zoomOutIconColor = '#0277BD'
        }.bind(this),
      )
    },
    addWhiteColorOnElementSelect(seat, svgDoc, orderItemId) {
      const selectedElement = svgDoc.getElementById(seat)
      let strokeWidth = 2
      if (
        document.getElementById('svgfile').getSVGDocument().getElementById(seat).hasAttribute('r')
      ) {
        strokeWidth =
          Number(
            document
              .getElementById('svgfile')
              .getSVGDocument()
              .getElementById(seat)
              .getAttribute('r'),
          ) * 0.4
      } else {
        strokeWidth = 2
      }
      selectedElement.style.fill = this.event.eventTemplateId
        ? this.orderItems.find(oi => oi.id === orderItemId).color
        : 'white'
      selectedElement.setAttribute(
        'fill',
        this.event.eventTemplateId
          ? this.orderItems.find(oi => oi.id === orderItemId).color
          : 'white',
      )
      selectedElement.setAttribute('stroke', '#333333')
      selectedElement.setAttribute('stroke-width', strokeWidth)
    },
    removeTicketFromCart(ticket, seat, svgDoc) {
      const seatHasSameColorAsCurrTicket = this.event.eventTemplateId
        ? svgDoc.getElementById(seat).getAttribute('fill') ===
          this.orderItems.find(oi => oi.id === this.currTicket).color
        : false
      const index = this.selectedTicket.findIndex(item => item.id === ticket.id)
      this.selectedTicket.splice(index, 1)
      const oldTicketId = svgDoc.getElementById(seat).getAttribute('ticketId')
      const oldTicket = this.orderItems.find(oi => oi.id === oldTicketId)
      if (ticket.itemMeta.table) {
        this.$emit('removeSelectedTableTickets', [
          ticket,
          seat,
          seatHasSameColorAsCurrTicket,
          oldTicket,
          this.elementDetails,
        ])
        delete this.elementDetails[seat]
      } else {
        this.$emit('removeSelectedTickets', [ticket, seat, seatHasSameColorAsCurrTicket, oldTicket])
      }
    },
    addTicketToCart(ticket, seat) {
      const addTicket = this.orderItems.find(
        oi => oi.id === (this.event.eventTemplateId ? this.currTicket : ticket.id),
      )
      this.selectedTicket.push(addTicket)
      this.$emit('addSelectedTickets', [addTicket, seat])
    },
    addParterAsTicketToCart(ticket) {
      this.$set(this.elementDetails, ticket.id, (this.elementDetails[ticket.id] || 0) + 1)
      this.$emit('addDialogElementToOrder', [
        ticket,
        this.elementDetails[ticket.id],
        TicketType.REGULAR,
      ])
      this.canAddMoreTickets = this.canAddMoreCheck()
    },
    removeParterAsTicketToCart(ticket) {
      if (!this.elementDetails[ticket.id]) {
        delete this.elementDetails[this.dialogElementId]
      } else {
        this.elementDetails[ticket.id] -= 1
      }
      const index = this.selectedTicket.findIndex(item => item.id === ticket.id)
      this.selectedTicket.splice(index, 1)
      this.$emit('addDialogElementToOrder', [
        ticket,
        this.elementDetails[ticket.id],
        TicketType.REGULAR,
      ])
      this.canAddMoreTickets = this.canAddMoreCheck()
    },
    handleTriggerTableTicketDialog(orderItem, seat) {
      if (orderItem.itemMeta.table) {
        this.switchElementDialogState()
        this.dialogElement = orderItem
        this.dialogElementId = seat
        this.initialFloorPlanDialogElementQuantity = orderItem.itemMeta.min
      }
    },
    switchElementDialogState() {
      this.openFloorPlanElementDialog = !this.openFloorPlanElementDialog
    },
    getSvgElementType(svgDoc, id) {
      return svgDoc.getElementById(id) && svgDoc.getElementById(id).getAttribute('ce-type')
    },
    handleParterClicked(svgDoc, parterId) {
      const parterOrderItem = this.orderItems.find(
        oi =>
          oi.itemMeta.parter &&
          moment().isBetween(oi.from, oi.to) &&
          oi.sectionSeats.includes(parterId),
      )
      if (
        Number(parterOrderItem.quantity) <= 0 ||
        (this.getNumOfSelectedElements() >= this.seatLimitPerOrder &&
          !this.elementDetails[parterId])
      ) {
        return
      }
      this.initialFloorPlanDialogElementQuantity = this.elementDetails[parterId] || 1
      this.switchElementDialogState()
      this.dialogElement = parterOrderItem
      this.dialogElementId = parterId
    },
    initialSvgColors(svgDoc) {
      svgDoc.getElementById('svgfile').style.touchAction = 'none'
      const delta = 6
      let startX
      let startY
      let multiTouch = false
      svgDoc.getElementById('svgfile').addEventListener(
        this.isMobile ? 'touchstart' : 'mousedown',
        function (e) {
          if (this.isMobile) {
            multiTouch = e.touches.length > 1
            startY = e.touches[0].clientY
            startX = e.touches[0].clientX
          } else {
            startY = e.pageY
            startX = e.pageX
          }
        }.bind(this),
      )

      this.isZkm &&
        document
          .querySelector('#svgfile')
          .contentDocument.addEventListener(this.isMobile ? '' : 'mouseover', e => {
            if (e.target.id.includes('Row-') && !e.target.getAttribute('sold')) {
              this.showSeatInfo(e.target.id, e)
            } else {
              this.hideSeatInfo()
            }
          })

      this.isZkm &&
        document
          .querySelector('#svgfile')
          .contentDocument.addEventListener(this.isMobile ? '' : 'mouseout', e => {
            if (!e.relatedTarget || !e.relatedTarget.id.includes('Row-')) {
              this.hideSeatInfo()
            }
          })

      document.querySelector('#svgfile').contentDocument.addEventListener(
        this.isMobile ? 'touchend' : 'mouseup',
        function (e) {
          const seatCheck = ['Seat-', 'Row-']
          const diffX = Math.abs(
            this.isMobile ? e.changedTouches[0].clientX - startX : e.pageX - startX,
          )
          const diffY = Math.abs(
            this.isMobile ? e.changedTouches[0].clientY - startY : e.pageY - startY,
          )
          if (
            !multiTouch &&
            diffX < delta &&
            diffY < delta &&
            this.venue.name.includes(Venue.ARENA_ZAGREB) &&
            this.getCurrZoom() <= 6
          ) {
            window.panZoom.zoomAtPoint(6.1, {
              x: startX,
              y: startY,
            })

            return
          }
          const clickedElement = e.target.id
          if (
            !multiTouch &&
            diffX < delta &&
            diffY < delta &&
            this.getSvgElementType(svgDoc, clickedElement) === SvgElementCEType.PARTER
          ) {
            return this.handleParterClicked(svgDoc, clickedElement)
          }
          if (
            !multiTouch &&
            diffX < delta &&
            diffY < delta &&
            seatCheck.every(check => e.target.id.includes(check))
          ) {
            const seat = clickedElement
            const seatTickets = this.orderItems.filter(
              oi => oi.sectionSeats.includes(seat) && moment().isBetween(oi.from, oi.to),
            )
            if (this.selectedSeats.includes(seat)) {
              if (this.currTicket) {
                const oi = this.orderItems.find(oi => oi.id === this.currTicket)
                const orderItemIsMembershipOnly = oi.membership
                const seatCurrTicketId = svgDoc.getElementById(seat).getAttribute('ticketId')
                if (
                  (orderItemIsMembershipOnly && seatCurrTicketId !== this.currTicket) ||
                  !oi.sectionSeats.includes(seat)
                ) {
                  return
                }
              }
              const seatHasSameColorAsCurrTicket = this.event.eventTemplateId
                ? svgDoc.getElementById(seat).getAttribute('fill') ===
                  this.orderItems.find(oi => oi.id === this.currTicket).color
                : true
              if (seatHasSameColorAsCurrTicket) {
                this.selectedSeats.splice(this.selectedSeats.indexOf(seat), 1)
              }
              this.removeTicketFromCart(
                this.event.eventTemplateId
                  ? this.orderItems.find(oi => oi.id === this.currTicket)
                  : seatTickets[0],
                seat,
                svgDoc,
              )
              if (this.event.eventTemplateId && !seatHasSameColorAsCurrTicket) {
                svgDoc.getElementById(seat).style.fill = this.orderItems.find(
                  oi => oi.id === this.currTicket,
                ).color
              } else {
                svgDoc.getElementById(seat).removeAttribute('stroke')
                svgDoc.getElementById(seat).style.fill = this.event.eventTemplateId
                  ? '#979797'
                  : seatTickets[0].color
              }
              svgDoc
                .getElementById(seat)
                .setAttribute(
                  'fill',
                  this.event.eventTemplateId
                    ? this.orderItems.find(oi => oi.id === this.currTicket).color
                    : seatTickets[0].color,
                )

              svgDoc
                .getElementById(seat)
                .setAttribute(
                  'ticketId',
                  this.event.eventTemplateId ? this.currTicket : seatTickets[0].id,
                )
              seatHasSameColorAsCurrTicket &&
                this.oneFreeSeatBetweenDeselectedSeatsCheck(seat, svgDoc)
              this.canAddMoreTickets = this.canAddMoreCheck()
            } else {
              if (
                !e.target.attributes.ticketId ||
                this.seatLimitPerOrder <= this.getNumOfSelectedElements()
              ) {
                return
              }
              if (this.currTicket) {
                const oi = this.orderItems.find(oi => oi.id === this.currTicket)
                if (!oi.sectionSeats.includes(e.target.id)) return
                const orderItemIsMembershipOnly = oi.membership
                if (orderItemIsMembershipOnly && this.ticketLocations[this.currTicket]) {
                  const numOfUsedMembershipTickets = this.ticketLocations[this.currTicket].reduce(
                    (acc, curr) => {
                      return (acc += curr.seats.length)
                    },
                    0,
                  )
                  if (numOfUsedMembershipTickets + 1 > this.membership.membershipPlan.amount) {
                    return
                  }
                }
              }
              const seat = e.target.id

              this.handleTriggerTableTicketDialog(seatTickets[0], seat)
              if (this.getSvgElementType(svgDoc, seat) === SvgElementCEType.TABLE) {
                return
              }
              this.$emit('getSeatPosition', seat)
              this.addWhiteColorOnElementSelect(seat, svgDoc, this.currTicket)
              this.selectedSeats.push(seat)
              this.addTicketToCart(
                this.event.eventTemplateId
                  ? this.orderItems.find(oi => oi.id === this.currTicket)
                  : seatTickets[0],
                seat,
              )
              svgDoc
                .getElementById(seat)
                .setAttribute(
                  'ticketId',
                  this.event.eventTemplateId ? this.currTicket : seatTickets[0].id,
                )
              this.oneFreeSeatBetweenSelectedSeatsCheck(seat, svgDoc)
              this.canAddMoreTickets = this.canAddMoreCheck()
              if (this.requiredSeats.includes(seat)) {
                this.requiredSeats = this.requiredSeats.filter(
                  requiredSeat => requiredSeat !== seat,
                )
                svgDoc.getElementById(seat).style.fill = 'white'
              }
            }
          }
        }.bind(this),
      )
      this.handleSeatColoring(svgDoc)
      this.handleParterColoring(svgDoc)
      svgDoc.getElementById('svg-pan-zoom-controls').remove()
      this.setZoomButtonsActions(svgDoc)
    },
    handleSeatColoring(svgDoc) {
      this.venue.seats.map(seat => {
        const seatTickets = this.orderItems.filter(
          oi => oi.sectionSeats.includes(seat) && moment().isBetween(oi.from, oi.to),
        )
        if (
          (this.venueAvailability[seat] &&
            this.venueAvailability[seat].state === this.seatState.AVAILABLE &&
            seatTickets.length &&
            (this.onlineSale || (!this.onlineSale && seatTickets[0].price > 0))) ||
          this.selectedSeats.includes(seat)
        ) {
          if (this.event.eventTemplateId) {
            const orderItem = this.orderItems.find(oi => oi.id === this.currTicket)
            svgDoc.getElementById(seat).style.fill = orderItem.sectionSeats.includes(seat)
              ? '#979797'
              : '#D9D9D9'
          } else {
            if (seat.includes('Row') && seat.includes('Seat')) {
              svgDoc.getElementById(seat).style.fill = seatTickets[0].color
            } else {
              svgDoc.getElementById(seat).style.fill = 'white'
            }
          }
          svgDoc.getElementById(seat).setAttribute('ticketId', this.currTicket)
          if (this.selectedSeats.includes(seat)) {
            if (this.event.eventTemplateId) {
              for (const [key, value] of Object.entries(this.ticketLocations)) {
                value.map(location =>
                  location.seats.map(seat => {
                    const seatId = `${location.section}_${location.row}_Seat-${seat}`
                    svgDoc.getElementById(seatId).setAttribute('ticketId', key)
                    this.addWhiteColorOnElementSelect(seatId, svgDoc, key)
                  }),
                )
              }
            } else {
              svgDoc.getElementById(seat).setAttribute('ticketId', seatTickets[0].id)
              this.addWhiteColorOnElementSelect(seat, svgDoc, this.currTicket)
            }
          }
        } else {
          svgDoc.getElementById(seat).style.fill = '#D9D9D9'
        }
      })
    },
    handleParterColoring(svgDoc) {
      const activeParterOrderItems = this.orderItems
        .filter(oi => oi.itemMeta.parter && moment().isBetween(oi.from, oi.to))
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      activeParterOrderItems.map(parterTicket => {
        if (!parterTicket.sectionSeats.length) {
          this.parterAsTicket.push(parterTicket)
        } else {
          parterTicket.sectionSeats.map(id => {
            svgDoc.getElementById(id).style.fill =
              parterTicket.quantity > 0 ? parterTicket.color : '#979797'
          })
        }
      })
    },
    hammerInit: function () {
      let eventsHandler
      eventsHandler = {
        haltEventListeners: ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel'],
        init: function (options) {
          let instance = options.instance,
            initialScale = 1,
            pannedX = 0,
            pannedY = 0

          // Init Hammer
          // Listen only for pointer and touch events
          this.hammer = Hammer(options.svgElement, {
            inputClass: Hammer.SUPPORT_POINTER_EVENTS
              ? Hammer.PointerEventInput
              : Hammer.TouchInput,
          })

          // Enable pinch
          this.hammer.get('pinch').set({
            enable: true,
          })

          // Handle double tap
          this.hammer.on('doubletap', function () {
            instance.zoomIn()
          })

          // Handle pan
          this.hammer.on('panstart panmove', function (ev) {
            // On pan start reset panned variables
            if (ev.type === 'panstart') {
              pannedX = 0
              pannedY = 0
            }

            // Pan only the difference
            instance.panBy({
              x: ev.deltaX - pannedX,
              y: ev.deltaY - pannedY,
            })
            pannedX = ev.deltaX
            pannedY = ev.deltaY
          })

          // Handle pinch
          this.hammer.on('pinchstart pinchmove', function (ev) {
            // On pinch start remember initial zoom
            if (ev.type === 'pinchstart') {
              initialScale = instance.getZoom()
              instance.zoomAtPoint(initialScale * ev.scale, {
                x: ev.center.x,
                y: ev.center.y,
              })
            }

            instance.zoomAtPoint(initialScale * ev.scale, {
              x: ev.center.x,
              y: ev.center.y,
            })
          })

          // Prevent moving the page on some devices when panning over SVG
          options.svgElement.addEventListener('touchmove', function (e) {
            e.preventDefault()
          })
        },
        destroy: function () {
          this.hammer.destroy()
        },
      }
      const beforePan = function (oldPan, newPan) {
        const svg1 = document.getElementById('svgfile')
        const zoomLevel = window.panZoom.getSizes().realZoom
        const svgWidth = svg1.clientWidth * zoomLevel

        const panXPercentage = 10
        const panYPercentage = 10

        const panXRange = (svgWidth * panXPercentage) / 100

        const svgCenterX = svgWidth / 2

        const minPanX = -svgCenterX + panXRange
        const maxPanX = svgCenterX - panXRange
        const minPanY = -svg1.clientHeight / 2
        const maxPanY = svg1.clientHeight / 2

        return {
          x: Math.max(minPanX, Math.min(maxPanX, newPan.x)),
          y: Math.max(minPanY, Math.min(maxPanY, newPan.y)),
        }
      }

      let maxZoom = this.isMobile ? 5 : 3
      if (this.venue.name.includes(Venue.ARENA_ZAGREB)) {
        if (this.isMobile) {
          maxZoom = 30
        } else {
          maxZoom = 7
        }
      }

      // Expose to window namespace for testing purposes
      window.panZoom = svgPanZoom('#svgfile', {
        zoomEnabled: true,
        controlIconsEnabled: true,
        maxZoom,
        fit: 2,
        center: 1,
        customEventsHandler: eventsHandler,
        beforePan:
          this.isMobile ||
          [Venue.ARENA_ZAGREB, Venue.LISINSKI_ZAGREB, 'Arena Zagreb 2'].includes(this.venue.name)
            ? null
            : beforePan,
      })
    },
    canAddParterTicket(ticket) {
      if (!ticket.itemMeta || !ticket.itemMeta.max) return true

      const currentlyAdded = this.elementDetails[ticket.id] || 0

      return currentlyAdded < ticket.itemMeta.max
    },
  },
}
</script>

<style scoped>
.seat-state-description-zkm {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-right: 2rem;
}

.zkm-seat-availability {
  display: flex;
  justify-content: flex-end;
  padding: 2rem;
  border: solid var(--grey-00, #333);
  border-width: 0 0 2px 0;
}

.floor-plan-wrapper-zkm {
  border: none !important;
}

.attendee-actions-zkm {
  visibility: hidden;
}

.screen-description {
  display: flex;
  width: 50%;
  border: 1px solid #979797;
  justify-content: space-between;
  padding: 10px 26px;
  border-radius: 8px;
}

.description-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #333333;
}

.description-title-zkm {
  font-weight: bold;
}

#description {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}

.ticket-color {
  height: 1rem;
  width: 1rem;
  border-radius: 1000px;
}

.ticket-container {
  border: 1px solid #333333;
  display: flex;
  column-gap: 0.5rem;
  border-radius: 2rem;
  align-items: center;
  padding: 0 0.5rem;
  margin-right: 0.5rem;
  background: white;
}

.ticket-wrapper {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  row-gap: 8px;
}

.ticket-wrapper-zkm {
  width: unset;
}

.floor-plan-wrapper {
  border: 1px solid #979797;
  height: fit-content;
  width: 100%;
  border-radius: 0.3rem;
  display: flex;
  flex-direction: column;
}

.title-ticket-wrapper {
  padding: 1rem 1.5rem;
  background: #f5f5f5;
  border-radius: 0.3rem 0.3rem 0 0;
  margin-bottom: 0.5rem;
  border-bottom: 1px solid #979797;
}

.title-ticket-wrapper-zkm {
  width: 100%;
  background: none;
  border-radius: 0;
  padding: 2rem 1.5rem;
  border: solid var(--grey-00, #333);
  border-width: 2px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media screen and (max-width: 500px) {
    flex-direction: column;
  }
}

.promo-style {
  margin-top: 2rem;
  margin-bottom: 24px;
  display: flex;
  width: 204px;
}

.center-icon {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  padding-top: 2px;
  text-transform: uppercase;
  margin-left: 6px;
}

.promoCode-wrapper {
  margin-top: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: left;
}

#addPromoCodeText {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 12px !important;
  line-height: 15px;
}

.attendee-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}

.seat-state-wrapper {
  display: flex;
  border-top: 1px solid #979797;
  padding: 1rem 1.5rem;
  column-gap: 0.5rem;
}

.seat-state-wrapper-zkm {
  display: none;
}

.selected-seat {
  height: 1rem;
  width: 1rem;
  background: white;
  border-radius: 100rem;
  border: 3px solid #333;
}

.unavailable-seat {
  height: 1rem;
  width: 1rem;
  background: #d9d9d9;
  border-radius: 100rem;
}

.available-seat {
  height: 1rem;
  width: 1rem;
  background: #979797;
  border-radius: 100rem;
}

.seat-state-description {
  display: flex;
  border: 1px solid #979797;
  border-radius: 2rem;
  align-items: center;
  column-gap: 0.5rem;
  padding: 0.2rem 0.5rem;
}

#svg-action-buttons-wrapper {
  display: flex;
  flex-direction: column;
  position: absolute;
  row-gap: 0.5rem;
  top: 20px;
  left: 21px;
}

.material-icons {
  user-select: none;
  cursor: pointer !important;
  background: white !important;
  height: fit-content;
  border-radius: 1000px !important;
  width: fit-content;
}

#spinner-container {
  height: 600px;
}

.no-tickets {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: start;
  padding-top: 1rem;
  gap: 1rem;
}

#spinner-svg-wrapper {
  height: 200px;
  overflow: hidden;
}

.ticket-price-currency {
  margin-bottom: 0;
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  color: #333333;
}

.ticket-name {
  margin-bottom: 0;
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
}

.ticket-container {
  display: inline-flex;
  align-items: center;
}

.circle {
  width: 10px; /* Adjust size as needed */
  height: 10px;
  border-radius: 50%;
  margin-right: 8px; /* Space between circle and text */
}
</style>
